// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/aimodelsbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Models Section styles */

#aimodels {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(180deg, #072258 0%, #0F4ABE 100%);
  background-size: contain, cover;
  background-position: right, center;
  background-repeat: no-repeat;
  padding: 80px 0;
  overflow: hidden;
}

.ai-models-section {
  position: relative;
  z-index: 2;
}

.ai-models-header {
  text-align: center;
  margin-bottom: 60px;
}

.ai-models-title {
  color: white;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
}

.ai-models-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.ai-model-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.ai-model-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  font-size: 20px;
}

.ai-model-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  margin-right: 60px;
}

.ai-model-desc {
  color: #cbd5e1;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.ai-models-cta {
  text-align: center;
}

.try-maia-btn {
  background: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 100px;
  padding: 15px 70px;
  font-size: 20px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
}

.try-maia-btn:hover {
  background: white;
  color: #0f172a;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ai-models-title {
    font-size: 2rem;
  }
  
  .ai-models-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .ai-model-card {
    padding: 25px;
  }
  
  .ai-model-title {
    font-size: 1.3rem;
  }
}

@media (max-width: 480px) {
  #aidmodels {
    padding: 60px 0;
  }
  
  .ai-models-title {
    font-size: 1.8rem;
  }
  
  .ai-model-card {
    padding: 20px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/LandingPage/LeadershipSection.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,sGAA4F;EAC5F,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* AI Models Section styles */\n\n#aimodels {\n  background: url('/public/aimodelsbg.png'), linear-gradient(180deg, #072258 0%, #0F4ABE 100%);\n  background-size: contain, cover;\n  background-position: right, center;\n  background-repeat: no-repeat;\n  padding: 80px 0;\n  overflow: hidden;\n}\n\n.ai-models-section {\n  position: relative;\n  z-index: 2;\n}\n\n.ai-models-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.ai-models-title {\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  line-height: 1.2;\n}\n\n.ai-models-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  margin-bottom: 60px;\n}\n\n.ai-model-card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.ai-model-icon {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #3b82f6;\n  font-size: 20px;\n}\n\n.ai-model-title {\n  color: white;\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  margin-right: 60px;\n}\n\n.ai-model-desc {\n  color: #cbd5e1;\n  font-size: 16px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.ai-models-cta {\n  text-align: center;\n}\n\n.try-maia-btn {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n  border-radius: 100px;\n  padding: 15px 70px;\n  font-size: 20px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.try-maia-btn:hover {\n  background: white;\n  color: #0f172a;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .ai-models-title {\n    font-size: 2rem;\n  }\n  \n  .ai-models-cards {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .ai-model-card {\n    padding: 25px;\n  }\n  \n  .ai-model-title {\n    font-size: 1.3rem;\n  }\n}\n\n@media (max-width: 480px) {\n  #aidmodels {\n    padding: 60px 0;\n  }\n  \n  .ai-models-title {\n    font-size: 1.8rem;\n  }\n  \n  .ai-model-card {\n    padding: 20px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
